import { ConfigProvider, Spin } from 'antd';
import './App.css';
import SearchInvoiceScreen from './SearchInvoice/SearchInvoice';
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { App as AntdApp } from 'antd';
import localStorageManagement from '../helper/services/localStorageServices';
import { useEffect, useMemo, useState } from 'react';
import SearchHangGiamThue from './SearchHangGiamThue/SearchHangGiamThue';
import { GlobalContext } from '../model/globalModel';
import { LoadingOutlined } from '@ant-design/icons';
import viVN from 'antd/lib/locale/vi_VN';
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
function App() {
  useEffect(() => {
    let user = localStorageManagement.getUser();
    let isValidToken = localStorageManagement.isValidToken();
    if (!user || !isValidToken) localStorageManagement.removeUser();
  }, [])
  const [isLoading, setLoading] = useState(false);
  return (
    <ConfigProvider theme={{
      token: {
        colorPrimary: '#363793',
        colorError: '#F7120C',
      }
    }}
      locale={viVN}>
      <AntdApp className='app'>
        <GlobalContext.Provider value={{ isLoading, setLoading }}>
          <Spin spinning={isLoading} indicator={antIcon}>
            {
              useMemo(
                () => (<BrowserRouter>
                  <Routes>
                    <Route index path='/*' Component={() => <SearchInvoiceScreen />} />
                    <Route path='tra-cuu-mat-hang-giam-thue-nghi-dinh-44-2023-nd-cp' element={<SearchHangGiamThue />} ></Route>
                  </Routes>
                </BrowserRouter>), []
              )
            }
          </Spin>
        </GlobalContext.Provider>
      </AntdApp>
    </ConfigProvider>

  );
}

export default App;
